import { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & { title?: string };

const AssetEditIcon = ({ title, ...props }: Props) => (
  <svg
    viewBox="0 0 20 20"
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={title ? undefined : true}
    role={title ? 'img' : 'presentation'}
    {...props}
  >
    <path
      d="M8.143 2.81a.905.905 0 0 1 0 1.81h-5.43a.905.905 0 0 0-.903.904v5.073L3.15 9.255a2.512 2.512 0 0 1 3.55 0l2.25 2.249.631-.631a2.515 2.515 0 0 1 3.555 0l1.339 1.339v-2.164a.905.905 0 0 1 1.81 0v6.334a2.718 2.718 0 0 1-2.715 2.714H2.714A2.717 2.717 0 0 1 0 16.382V5.524A2.718 2.718 0 0 1 2.714 2.81h5.429Zm-3.217 7.528a.723.723 0 0 0-.495.196L1.81 13.155v3.227a.905.905 0 0 0 .904.904h9.453l-3.86-3.86c-.008-.007-.01-.018-.019-.027l-2.866-2.865a.724.724 0 0 0-.496-.196Zm6.433 1.608a.707.707 0 0 0-.498.205l-.632.632 4.085 4.084a.878.878 0 0 0 .162-.485V14.77l-2.62-2.619a.706.706 0 0 0-.497-.205ZM12.666 0a1 1 0 0 1 .995.904h.815a1 1 0 0 1 0 2h-2.262a.36.36 0 0 0-.358.358.36.36 0 0 0 .358.357h.904a2.36 2.36 0 0 1 2.358 2.358 2.357 2.357 0 0 1-1.812 2.29.999.999 0 0 1-1.993.066h-.815a1 1 0 0 1 0-2h2.262a.358.358 0 0 0 .253-.61.36.36 0 0 0-.253-.104h-.904a2.359 2.359 0 0 1-1.667-4.024c.31-.31.7-.523 1.12-.623A1 1 0 0 1 12.666 0Z"
      fill="currentColor"
    />
  </svg>
);

export default AssetEditIcon;
